import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label", "title", "aria-pressed", "onClick"]
const _hoisted_4 = { class: "motion-mode-label" }
const _hoisted_5 = { class: "motion-mode-code" }
const _hoisted_6 = {
  key: 0,
  class: "camera-notice"
}
const _hoisted_7 = { class: "slot-heading" }
const _hoisted_8 = {
  key: 1,
  class: "camera-notice"
}
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "slot-index" }
const _hoisted_11 = ["aria-label", "onClick"]
const _hoisted_12 = { class: "slot-fields" }
const _hoisted_13 = {
  key: 0,
  class: "rot-hint"
}
const _hoisted_14 = {
  key: 3,
  class: "motion-extras"
}

import { computed } from "vue";
import { CAMERA_POSITION_PROPERTIES, CAMERA_ROTATION_PROPERTIES, normalizeCameraMotion } from "../../config/cameraClip";
import { createClipPropertyValues, getClipListLimits, getClipNestedProperties, isClipPropertyVisible, updateClipStructField } from "../../utils/clipProperties";
import ClipPropertyEditor from "./ClipPropertyEditor.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CameraMotionEditor',
  props: {
    kind: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const definitions = computed(() => props.kind === "position" ? CAMERA_POSITION_PROPERTIES : CAMERA_ROTATION_PROPERTIES);
const slotFields = computed(() => {
  const fields = getClipNestedProperties(definitions.value.find(field => field.key === "slot")!, value.value);
  // Presentation order only: point type on the left, coordinate space on the right.
  return [...fields.filter(field => field.key === "pointType"), ...fields.filter(field => field.key !== "pointType")];
});
const value = computed(() => createClipPropertyValues(definitions.value, normalizeCameraMotion(props.modelValue, props.kind)));
const mode = computed(() => String(value.value.type));
const slots = computed(() => value.value.slot as Record<string, unknown>[]);
const limits = computed(() => getClipListLimits(definitions.value.find(field => field.key === "slot")!, value.value));
const modes = computed(() => definitions.value[0].options ?? []);
const extras = computed(() => definitions.value.filter(field => field.key !== "type" && field.key !== "slot" && isClipPropertyVisible(field, value.value)));
function update(key: string, next: unknown) { emit("update:modelValue", updateClipStructField(definitions.value, value.value, key, next)); }
function updateSlot(index: number, key: string, next: unknown) {
  update("slot", slots.value.map((slot, i) => i === index ? { ...slot, [key]: next } : slot));
}
function addSlot() {
  if (slots.value.length >= limits.value.max) return;
  const point = createClipPropertyValues(slotFields.value);
  update("slot", mode.value === "NOLOC_Linear" ? [point, ...slots.value] : [...slots.value, point]);
}
function removeSlot(index: number) { if (slots.value.length > limits.value.min) update("slot", slots.value.filter((_, i) => i !== index)); }
function swapSlots() { update("slot", [...slots.value].reverse()); }
function slotName(index: number) {
  if (mode.value === "NOLOC_Linear") return slots.value.length === 1 ? "终点" : index === 0 ? "起点" : index === 1 ? "终点" : `点位 ${index + 1}`;
  if (mode.value === "NOLOC_Orbit") return "环绕中心";
  if (mode.value === "NOLOC_Follow" || mode.value === "NOLOC_LookAt") return "目标点位";
  return props.kind === "position" ? "固定位置" : "固定角度";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "camera-motion",
    "aria-label": __props.kind === 'position' ? '相机位置设置' : '视点位置设置'
  }, [
    _createElementVNode("div", {
      class: "motion-modes",
      role: "group",
      "aria-label": __props.kind === 'position' ? '相机位置类型' : '视点位置类型'
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modes.value, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: String(item.value),
          type: "button",
          class: "motion-mode-button",
          "aria-label": item.label,
          title: `${item.label}（${item.value}）`,
          "aria-pressed": mode.value === item.value,
          onClick: ($event: any) => (update('type', item.value))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
          _createElementVNode("small", _hoisted_5, _toDisplayString(item.value), 1)
        ], 8, _hoisted_3))
      }), 128))
    ], 8, _hoisted_2),
    (!modes.value.some(item => item.value === mode.value))
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "当前类型：" + _toDisplayString(mode.value || '未设置') + "。请选择上方类型。", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", null, _toDisplayString(mode.value === 'NOLOC_Linear' ? '运动点位' : '点位设置'), 1),
      _createElementVNode("small", null, _toDisplayString(slots.value.length) + " / " + _toDisplayString(limits.value.max) + " Slot", 1),
      (mode.value === 'NOLOC_Linear' && slots.value.length === 2)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: swapSlots
          }, "交换起终点"))
        : _createCommentVNode("", true)
    ]),
    (slots.value.length > limits.value.max)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "当前类型只允许 " + _toDisplayString(limits.value.max) + " 个点位，请移除多余点位。", 1))
      : _createCommentVNode("", true),
    (slots.value.length < limits.value.max)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "add-target",
          onClick: addSlot
        }, "＋ 添加起点（若不填写起点则获取当前位置）"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slots.value, (slot, index) => {
      return (_openBlock(), _createElementBlock("article", {
        key: index,
        class: "camera-slot",
        "aria-label": slotName(index)
      }, [
        _createElementVNode("header", null, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(String(index + 1).padStart(2, '0')), 1),
          _createElementVNode("strong", null, _toDisplayString(slotName(index)), 1),
          (slots.value.length > limits.value.min)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "remove-slot",
                "aria-label": `删除${slotName(index)}`,
                onClick: ($event: any) => (removeSlot(index))
              }, "移除", 8, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotFields.value.filter(field => _unref(isClipPropertyVisible)(field, slot)), (field) => {
            return (_openBlock(), _createBlock(ClipPropertyEditor, {
              key: field.key,
              class: _normalizeClass({ 'half-field': field.key === 'space' || field.key === 'pointType' }),
              property: __props.kind === 'rotation' && slot.pointType === 'NOLOC_Rot' && field.key === 'vector3' ? { ...field, label: '旋转' } : field,
              "model-value": slot[field.key],
              "sibling-values": slot,
              "onUpdate:modelValue": ($event: any) => (updateSlot(index, field.key, $event))
            }, null, 8, ["class", "property", "model-value", "sibling-values", "onUpdate:modelValue"]))
          }), 128))
        ]),
        (__props.kind === 'rotation' && slot.pointType === 'NOLOC_Rot')
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "根据旋转确定视点位置"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_9))
    }), 128)),
    (extras.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extras.value, (field) => {
            return (_openBlock(), _createBlock(ClipPropertyEditor, {
              key: field.key,
              property: field,
              "model-value": value.value[field.key],
              "sibling-values": value.value,
              "onUpdate:modelValue": ($event: any) => (update(field.key, $event))
            }, null, 8, ["property", "model-value", "sibling-values", "onUpdate:modelValue"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})